/**
 * Environment-derived checks shared across features. Single source of truth
 * for "are we in production" so the comparison isn't re-implemented per
 * call site (previously duplicated between `constructShopifyUrl.ts` and
 * `constants/clarity.ts`).
 */
import { AUTH_CONFIG } from 'config/auth.config';
import { PRODUCTION_API_ORIGINS } from 'constants/env';

export const isProductionServer = (): boolean =>
  PRODUCTION_API_ORIGINS.includes(AUTH_CONFIG.API_BASE_URL);
